export * from './get-domain-ids';
